import styled from 'styled-components';
import { Icon as SemanticIcon } from 'semantic-ui-react';

export const ItemIcon = styled(SemanticIcon)`
  flex: 1;
  padding: 8px 0 8px 0;
`;
